import { Navigate, Outlet } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useMe } from '../../api/auth'

/**
 * Route element that lets nested routes render only when the current user
 * is a superadmin. Belt-and-suspenders with the backend 403 — this just
 * prevents non-superadmins from rendering an empty error shell when they
 * follow a bookmark, and lets us hide nav links cleanly.
 */
export function SuperadminGate() {
  const { t } = useTranslation('common')
  const { data: me, isLoading } = useMe()
  if (isLoading) return <div className="p-8 text-text-secondary">{t('states.loading')}</div>
  if (!me?.is_superadmin) return <Navigate to="/app" replace />
  return <Outlet />
}
